import { call, take, put } from 'redux-saga/effects';
import * as errorActions from '../errors/actions';
import * as actions from './actions';
import * as services from './services';

export function* fetchSchools() {
  while (true) {
    try {
      const action = yield take(actions.FETCH_SCHOOLS_REQUEST);

      if (action.payload.query) {
        const response = yield call(services.fetchSchools, { query: action.payload.query });

        yield put(actions.fetchSchoolsSuccess({ schools: response.data }));
      } else {
        yield put(actions.initSchools());
      }
    } catch (error) {
      yield put(actions.fetchSchoolsFailure({ error }));

      yield put(errorActions.errorOccured({ error }));
    }
  }
}
